export { default as ScalarErrorBoundary } from "./ScalarErrorBoundary.vue.js";
